/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StaticWelcomeRouteImport } from './routes/static/welcome'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as StaticLayoutRouteRouteImport } from './routes/static/_layout/route'
import { Route as CallbackStripeRouteRouteImport } from './routes/callback/stripe/route'
import { Route as AuthLayoutRouteRouteImport } from './routes/auth/_layout/route'
import { Route as AppRoleRouteRouteImport } from './routes/app/$role/route'
import { Route as StaticLayoutTermsRouteImport } from './routes/static/_layout/terms'
import { Route as StaticLayoutQuickHelpRouteImport } from './routes/static/_layout/quick-help'
import { Route as StaticLayoutPrivacyRouteImport } from './routes/static/_layout/privacy'
import { Route as PaymentReturnUserIdRouteImport } from './routes/payment/return/$userId'
import { Route as CallbackStripeSetupRouteImport } from './routes/callback/stripe/setup'
import { Route as AuthLayoutVerificationRouteImport } from './routes/auth/_layout/verification'
import { Route as AuthLayoutSuccessRouteImport } from './routes/auth/_layout/success'
import { Route as AuthLayoutSignupRouteImport } from './routes/auth/_layout/signup'
import { Route as AuthLayoutPasswordResetRouteImport } from './routes/auth/_layout/password-reset'
import { Route as AuthLayoutNewPasswordRouteImport } from './routes/auth/_layout/new-password'
import { Route as AuthLayoutForgotPasswordRouteImport } from './routes/auth/_layout/forgot-password'
import { Route as AuthLayoutEmailConfirmationRouteImport } from './routes/auth/_layout/email-confirmation'
import { Route as AppRoleSetupRouteRouteImport } from './routes/app/$role/setup/route'
import { Route as AppRoleAppRouteRouteImport } from './routes/app/$role/_app/route'
import { Route as AppRoleSetupIndexRouteImport } from './routes/app/$role/setup/index'
import { Route as AppRoleBillingResolveRouteImport } from './routes/app/$role/billing/resolve'
import { Route as AppProfileWorkerWorkerIdRouteRouteImport } from './routes/app/profile/worker/$workerId/route'
import { Route as AppProfileEmployerEmployerIdRouteRouteImport } from './routes/app/profile/employer/$employerId/route'
import { Route as AppProfileWorkerWorkerIdIndexRouteImport } from './routes/app/profile/worker/$workerId/index'
import { Route as AppProfileEmployerEmployerIdIndexRouteImport } from './routes/app/profile/employer/$employerId/index'
import { Route as AppRoleAppShiftsIndexRouteImport } from './routes/app/$role/_app/shifts/index'
import { Route as AppRoleAppSettingsIndexRouteImport } from './routes/app/$role/_app/settings/index'
import { Route as AppRoleAppSearchIndexRouteImport } from './routes/app/$role/_app/search/index'
import { Route as AppRoleAppScheduleIndexRouteImport } from './routes/app/$role/_app/schedule/index'
import { Route as AppRoleAppRosterIndexRouteImport } from './routes/app/$role/_app/roster/index'
import { Route as AppRoleAppPostAvailabilityIndexRouteImport } from './routes/app/$role/_app/post-availability/index'
import { Route as AppRoleAppPaymentsIndexRouteImport } from './routes/app/$role/_app/payments/index'
import { Route as AppRoleAppMessagesIndexRouteImport } from './routes/app/$role/_app/messages/index'
import { Route as AppRoleAppDashboardIndexRouteImport } from './routes/app/$role/_app/dashboard/index'
import { Route as AppRoleAppContactIndexRouteImport } from './routes/app/$role/_app/contact/index'
import { Route as AppRoleAppAvailableIndexRouteImport } from './routes/app/$role/_app/available/index'
import { Route as AppRoleAppActivityIndexRouteImport } from './routes/app/$role/_app/activity/index'
import { Route as AppProfileWorkerWorkerIdSendOfferRouteImport } from './routes/app/profile/worker/$workerId/send-offer'
import { Route as AppRoleAppSearchListRouteImport } from './routes/app/$role/_app/search/list'
import { Route as AppRoleAppRosterAddRouteImport } from './routes/app/$role/_app/roster/add'
import { Route as AppProfileWorkerWorkerIdReviewIndexRouteImport } from './routes/app/profile/worker/$workerId/review/index'
import { Route as AppProfileWorkerWorkerIdRatingsIndexRouteImport } from './routes/app/profile/worker/$workerId/ratings/index'
import { Route as AppProfileEmployerEmployerIdReviewIndexRouteImport } from './routes/app/profile/employer/$employerId/review/index'
import { Route as AppProfileEmployerEmployerIdRatingsIndexRouteImport } from './routes/app/profile/employer/$employerId/ratings/index'
import { Route as AppRoleAppShiftsNewIndexRouteImport } from './routes/app/$role/_app/shifts/new/index'
import { Route as AppRoleAppDashboardShiftShiftIdRouteImport } from './routes/app/$role/_app/dashboard/shift/$shiftId'
import { Route as AppRoleAppShiftsShiftIdEditIndexRouteImport } from './routes/app/$role/_app/shifts/$shiftId/edit/index'

const StaticRouteImport = createFileRoute('/static')()
const AuthRouteImport = createFileRoute('/auth')()

const StaticRoute = StaticRouteImport.update({
  id: '/static',
  path: '/static',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StaticWelcomeRoute = StaticWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => StaticRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const StaticLayoutRouteRoute = StaticLayoutRouteRouteImport.update({
  id: '/_layout',
  getParentRoute: () => StaticRoute,
} as any)
const CallbackStripeRouteRoute = CallbackStripeRouteRouteImport.update({
  id: '/callback/stripe',
  path: '/callback/stripe',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutRouteRoute = AuthLayoutRouteRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AuthRoute,
} as any)
const AppRoleRouteRoute = AppRoleRouteRouteImport.update({
  id: '/$role',
  path: '/$role',
  getParentRoute: () => AppRouteRoute,
} as any)
const StaticLayoutTermsRoute = StaticLayoutTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => StaticLayoutRouteRoute,
} as any)
const StaticLayoutQuickHelpRoute = StaticLayoutQuickHelpRouteImport.update({
  id: '/quick-help',
  path: '/quick-help',
  getParentRoute: () => StaticLayoutRouteRoute,
} as any)
const StaticLayoutPrivacyRoute = StaticLayoutPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => StaticLayoutRouteRoute,
} as any)
const PaymentReturnUserIdRoute = PaymentReturnUserIdRouteImport.update({
  id: '/payment/return/$userId',
  path: '/payment/return/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackStripeSetupRoute = CallbackStripeSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => CallbackStripeRouteRoute,
} as any)
const AuthLayoutVerificationRoute = AuthLayoutVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any)
const AuthLayoutSuccessRoute = AuthLayoutSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any)
const AuthLayoutSignupRoute = AuthLayoutSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any)
const AuthLayoutPasswordResetRoute = AuthLayoutPasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any)
const AuthLayoutNewPasswordRoute = AuthLayoutNewPasswordRouteImport.update({
  id: '/new-password',
  path: '/new-password',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any)
const AuthLayoutForgotPasswordRoute =
  AuthLayoutForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any)
const AuthLayoutEmailConfirmationRoute =
  AuthLayoutEmailConfirmationRouteImport.update({
    id: '/email-confirmation',
    path: '/email-confirmation',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any)
const AppRoleSetupRouteRoute = AppRoleSetupRouteRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppRoleRouteRoute,
} as any)
const AppRoleAppRouteRoute = AppRoleAppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => AppRoleRouteRoute,
} as any)
const AppRoleSetupIndexRoute = AppRoleSetupIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoleSetupRouteRoute,
} as any)
const AppRoleBillingResolveRoute = AppRoleBillingResolveRouteImport.update({
  id: '/billing/resolve',
  path: '/billing/resolve',
  getParentRoute: () => AppRoleRouteRoute,
} as any)
const AppProfileWorkerWorkerIdRouteRoute =
  AppProfileWorkerWorkerIdRouteRouteImport.update({
    id: '/profile/worker/$workerId',
    path: '/profile/worker/$workerId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppProfileEmployerEmployerIdRouteRoute =
  AppProfileEmployerEmployerIdRouteRouteImport.update({
    id: '/profile/employer/$employerId',
    path: '/profile/employer/$employerId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppProfileWorkerWorkerIdIndexRoute =
  AppProfileWorkerWorkerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProfileWorkerWorkerIdRouteRoute,
  } as any)
const AppProfileEmployerEmployerIdIndexRoute =
  AppProfileEmployerEmployerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProfileEmployerEmployerIdRouteRoute,
  } as any)
const AppRoleAppShiftsIndexRoute = AppRoleAppShiftsIndexRouteImport.update({
  id: '/shifts/',
  path: '/shifts/',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppRoleAppSettingsIndexRoute = AppRoleAppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppRoleAppSearchIndexRoute = AppRoleAppSearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppRoleAppScheduleIndexRoute = AppRoleAppScheduleIndexRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppRoleAppRosterIndexRoute = AppRoleAppRosterIndexRouteImport.update({
  id: '/roster/',
  path: '/roster/',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppRoleAppPostAvailabilityIndexRoute =
  AppRoleAppPostAvailabilityIndexRouteImport.update({
    id: '/post-availability/',
    path: '/post-availability/',
    getParentRoute: () => AppRoleAppRouteRoute,
  } as any)
const AppRoleAppPaymentsIndexRoute = AppRoleAppPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppRoleAppMessagesIndexRoute = AppRoleAppMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppRoleAppDashboardIndexRoute =
  AppRoleAppDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AppRoleAppRouteRoute,
  } as any)
const AppRoleAppContactIndexRoute = AppRoleAppContactIndexRouteImport.update({
  id: '/contact/',
  path: '/contact/',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppRoleAppAvailableIndexRoute =
  AppRoleAppAvailableIndexRouteImport.update({
    id: '/available/',
    path: '/available/',
    getParentRoute: () => AppRoleAppRouteRoute,
  } as any)
const AppRoleAppActivityIndexRoute = AppRoleAppActivityIndexRouteImport.update({
  id: '/activity/',
  path: '/activity/',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppProfileWorkerWorkerIdSendOfferRoute =
  AppProfileWorkerWorkerIdSendOfferRouteImport.update({
    id: '/send-offer',
    path: '/send-offer',
    getParentRoute: () => AppProfileWorkerWorkerIdRouteRoute,
  } as any)
const AppRoleAppSearchListRoute = AppRoleAppSearchListRouteImport.update({
  id: '/search/list',
  path: '/search/list',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppRoleAppRosterAddRoute = AppRoleAppRosterAddRouteImport.update({
  id: '/roster/add',
  path: '/roster/add',
  getParentRoute: () => AppRoleAppRouteRoute,
} as any)
const AppProfileWorkerWorkerIdReviewIndexRoute =
  AppProfileWorkerWorkerIdReviewIndexRouteImport.update({
    id: '/review/',
    path: '/review/',
    getParentRoute: () => AppProfileWorkerWorkerIdRouteRoute,
  } as any)
const AppProfileWorkerWorkerIdRatingsIndexRoute =
  AppProfileWorkerWorkerIdRatingsIndexRouteImport.update({
    id: '/ratings/',
    path: '/ratings/',
    getParentRoute: () => AppProfileWorkerWorkerIdRouteRoute,
  } as any)
const AppProfileEmployerEmployerIdReviewIndexRoute =
  AppProfileEmployerEmployerIdReviewIndexRouteImport.update({
    id: '/review/',
    path: '/review/',
    getParentRoute: () => AppProfileEmployerEmployerIdRouteRoute,
  } as any)
const AppProfileEmployerEmployerIdRatingsIndexRoute =
  AppProfileEmployerEmployerIdRatingsIndexRouteImport.update({
    id: '/ratings/',
    path: '/ratings/',
    getParentRoute: () => AppProfileEmployerEmployerIdRouteRoute,
  } as any)
const AppRoleAppShiftsNewIndexRoute =
  AppRoleAppShiftsNewIndexRouteImport.update({
    id: '/shifts/new/',
    path: '/shifts/new/',
    getParentRoute: () => AppRoleAppRouteRoute,
  } as any)
const AppRoleAppDashboardShiftShiftIdRoute =
  AppRoleAppDashboardShiftShiftIdRouteImport.update({
    id: '/dashboard/shift/$shiftId',
    path: '/dashboard/shift/$shiftId',
    getParentRoute: () => AppRoleAppRouteRoute,
  } as any)
const AppRoleAppShiftsShiftIdEditIndexRoute =
  AppRoleAppShiftsShiftIdEditIndexRouteImport.update({
    id: '/shifts/$shiftId/edit/',
    path: '/shifts/$shiftId/edit/',
    getParentRoute: () => AppRoleAppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/app/$role': typeof AppRoleAppRouteRouteWithChildren
  '/auth': typeof AuthLayoutRouteRouteWithChildren
  '/callback/stripe': typeof CallbackStripeRouteRouteWithChildren
  '/static': typeof StaticLayoutRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/static/welcome': typeof StaticWelcomeRoute
  '/app/$role/setup': typeof AppRoleSetupRouteRouteWithChildren
  '/auth/email-confirmation': typeof AuthLayoutEmailConfirmationRoute
  '/auth/forgot-password': typeof AuthLayoutForgotPasswordRoute
  '/auth/new-password': typeof AuthLayoutNewPasswordRoute
  '/auth/password-reset': typeof AuthLayoutPasswordResetRoute
  '/auth/signup': typeof AuthLayoutSignupRoute
  '/auth/success': typeof AuthLayoutSuccessRoute
  '/auth/verification': typeof AuthLayoutVerificationRoute
  '/callback/stripe/setup': typeof CallbackStripeSetupRoute
  '/payment/return/$userId': typeof PaymentReturnUserIdRoute
  '/static/privacy': typeof StaticLayoutPrivacyRoute
  '/static/quick-help': typeof StaticLayoutQuickHelpRoute
  '/static/terms': typeof StaticLayoutTermsRoute
  '/app/profile/employer/$employerId': typeof AppProfileEmployerEmployerIdRouteRouteWithChildren
  '/app/profile/worker/$workerId': typeof AppProfileWorkerWorkerIdRouteRouteWithChildren
  '/app/$role/billing/resolve': typeof AppRoleBillingResolveRoute
  '/app/$role/setup/': typeof AppRoleSetupIndexRoute
  '/app/$role/roster/add': typeof AppRoleAppRosterAddRoute
  '/app/$role/search/list': typeof AppRoleAppSearchListRoute
  '/app/profile/worker/$workerId/send-offer': typeof AppProfileWorkerWorkerIdSendOfferRoute
  '/app/$role/activity': typeof AppRoleAppActivityIndexRoute
  '/app/$role/available': typeof AppRoleAppAvailableIndexRoute
  '/app/$role/contact': typeof AppRoleAppContactIndexRoute
  '/app/$role/dashboard': typeof AppRoleAppDashboardIndexRoute
  '/app/$role/messages': typeof AppRoleAppMessagesIndexRoute
  '/app/$role/payments': typeof AppRoleAppPaymentsIndexRoute
  '/app/$role/post-availability': typeof AppRoleAppPostAvailabilityIndexRoute
  '/app/$role/roster': typeof AppRoleAppRosterIndexRoute
  '/app/$role/schedule': typeof AppRoleAppScheduleIndexRoute
  '/app/$role/search': typeof AppRoleAppSearchIndexRoute
  '/app/$role/settings': typeof AppRoleAppSettingsIndexRoute
  '/app/$role/shifts': typeof AppRoleAppShiftsIndexRoute
  '/app/profile/employer/$employerId/': typeof AppProfileEmployerEmployerIdIndexRoute
  '/app/profile/worker/$workerId/': typeof AppProfileWorkerWorkerIdIndexRoute
  '/app/$role/dashboard/shift/$shiftId': typeof AppRoleAppDashboardShiftShiftIdRoute
  '/app/$role/shifts/new': typeof AppRoleAppShiftsNewIndexRoute
  '/app/profile/employer/$employerId/ratings': typeof AppProfileEmployerEmployerIdRatingsIndexRoute
  '/app/profile/employer/$employerId/review': typeof AppProfileEmployerEmployerIdReviewIndexRoute
  '/app/profile/worker/$workerId/ratings': typeof AppProfileWorkerWorkerIdRatingsIndexRoute
  '/app/profile/worker/$workerId/review': typeof AppProfileWorkerWorkerIdReviewIndexRoute
  '/app/$role/shifts/$shiftId/edit': typeof AppRoleAppShiftsShiftIdEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/app/$role': typeof AppRoleAppRouteRouteWithChildren
  '/auth': typeof AuthLayoutRouteRouteWithChildren
  '/callback/stripe': typeof CallbackStripeRouteRouteWithChildren
  '/static': typeof StaticLayoutRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/static/welcome': typeof StaticWelcomeRoute
  '/auth/email-confirmation': typeof AuthLayoutEmailConfirmationRoute
  '/auth/forgot-password': typeof AuthLayoutForgotPasswordRoute
  '/auth/new-password': typeof AuthLayoutNewPasswordRoute
  '/auth/password-reset': typeof AuthLayoutPasswordResetRoute
  '/auth/signup': typeof AuthLayoutSignupRoute
  '/auth/success': typeof AuthLayoutSuccessRoute
  '/auth/verification': typeof AuthLayoutVerificationRoute
  '/callback/stripe/setup': typeof CallbackStripeSetupRoute
  '/payment/return/$userId': typeof PaymentReturnUserIdRoute
  '/static/privacy': typeof StaticLayoutPrivacyRoute
  '/static/quick-help': typeof StaticLayoutQuickHelpRoute
  '/static/terms': typeof StaticLayoutTermsRoute
  '/app/$role/billing/resolve': typeof AppRoleBillingResolveRoute
  '/app/$role/setup': typeof AppRoleSetupIndexRoute
  '/app/$role/roster/add': typeof AppRoleAppRosterAddRoute
  '/app/$role/search/list': typeof AppRoleAppSearchListRoute
  '/app/profile/worker/$workerId/send-offer': typeof AppProfileWorkerWorkerIdSendOfferRoute
  '/app/$role/activity': typeof AppRoleAppActivityIndexRoute
  '/app/$role/available': typeof AppRoleAppAvailableIndexRoute
  '/app/$role/contact': typeof AppRoleAppContactIndexRoute
  '/app/$role/dashboard': typeof AppRoleAppDashboardIndexRoute
  '/app/$role/messages': typeof AppRoleAppMessagesIndexRoute
  '/app/$role/payments': typeof AppRoleAppPaymentsIndexRoute
  '/app/$role/post-availability': typeof AppRoleAppPostAvailabilityIndexRoute
  '/app/$role/roster': typeof AppRoleAppRosterIndexRoute
  '/app/$role/schedule': typeof AppRoleAppScheduleIndexRoute
  '/app/$role/search': typeof AppRoleAppSearchIndexRoute
  '/app/$role/settings': typeof AppRoleAppSettingsIndexRoute
  '/app/$role/shifts': typeof AppRoleAppShiftsIndexRoute
  '/app/profile/employer/$employerId': typeof AppProfileEmployerEmployerIdIndexRoute
  '/app/profile/worker/$workerId': typeof AppProfileWorkerWorkerIdIndexRoute
  '/app/$role/dashboard/shift/$shiftId': typeof AppRoleAppDashboardShiftShiftIdRoute
  '/app/$role/shifts/new': typeof AppRoleAppShiftsNewIndexRoute
  '/app/profile/employer/$employerId/ratings': typeof AppProfileEmployerEmployerIdRatingsIndexRoute
  '/app/profile/employer/$employerId/review': typeof AppProfileEmployerEmployerIdReviewIndexRoute
  '/app/profile/worker/$workerId/ratings': typeof AppProfileWorkerWorkerIdRatingsIndexRoute
  '/app/profile/worker/$workerId/review': typeof AppProfileWorkerWorkerIdReviewIndexRoute
  '/app/$role/shifts/$shiftId/edit': typeof AppRoleAppShiftsShiftIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/app/$role': typeof AppRoleRouteRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/auth/_layout': typeof AuthLayoutRouteRouteWithChildren
  '/callback/stripe': typeof CallbackStripeRouteRouteWithChildren
  '/static': typeof StaticRouteWithChildren
  '/static/_layout': typeof StaticLayoutRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/static/welcome': typeof StaticWelcomeRoute
  '/app/$role/_app': typeof AppRoleAppRouteRouteWithChildren
  '/app/$role/setup': typeof AppRoleSetupRouteRouteWithChildren
  '/auth/_layout/email-confirmation': typeof AuthLayoutEmailConfirmationRoute
  '/auth/_layout/forgot-password': typeof AuthLayoutForgotPasswordRoute
  '/auth/_layout/new-password': typeof AuthLayoutNewPasswordRoute
  '/auth/_layout/password-reset': typeof AuthLayoutPasswordResetRoute
  '/auth/_layout/signup': typeof AuthLayoutSignupRoute
  '/auth/_layout/success': typeof AuthLayoutSuccessRoute
  '/auth/_layout/verification': typeof AuthLayoutVerificationRoute
  '/callback/stripe/setup': typeof CallbackStripeSetupRoute
  '/payment/return/$userId': typeof PaymentReturnUserIdRoute
  '/static/_layout/privacy': typeof StaticLayoutPrivacyRoute
  '/static/_layout/quick-help': typeof StaticLayoutQuickHelpRoute
  '/static/_layout/terms': typeof StaticLayoutTermsRoute
  '/app/profile/employer/$employerId': typeof AppProfileEmployerEmployerIdRouteRouteWithChildren
  '/app/profile/worker/$workerId': typeof AppProfileWorkerWorkerIdRouteRouteWithChildren
  '/app/$role/billing/resolve': typeof AppRoleBillingResolveRoute
  '/app/$role/setup/': typeof AppRoleSetupIndexRoute
  '/app/$role/_app/roster/add': typeof AppRoleAppRosterAddRoute
  '/app/$role/_app/search/list': typeof AppRoleAppSearchListRoute
  '/app/profile/worker/$workerId/send-offer': typeof AppProfileWorkerWorkerIdSendOfferRoute
  '/app/$role/_app/activity/': typeof AppRoleAppActivityIndexRoute
  '/app/$role/_app/available/': typeof AppRoleAppAvailableIndexRoute
  '/app/$role/_app/contact/': typeof AppRoleAppContactIndexRoute
  '/app/$role/_app/dashboard/': typeof AppRoleAppDashboardIndexRoute
  '/app/$role/_app/messages/': typeof AppRoleAppMessagesIndexRoute
  '/app/$role/_app/payments/': typeof AppRoleAppPaymentsIndexRoute
  '/app/$role/_app/post-availability/': typeof AppRoleAppPostAvailabilityIndexRoute
  '/app/$role/_app/roster/': typeof AppRoleAppRosterIndexRoute
  '/app/$role/_app/schedule/': typeof AppRoleAppScheduleIndexRoute
  '/app/$role/_app/search/': typeof AppRoleAppSearchIndexRoute
  '/app/$role/_app/settings/': typeof AppRoleAppSettingsIndexRoute
  '/app/$role/_app/shifts/': typeof AppRoleAppShiftsIndexRoute
  '/app/profile/employer/$employerId/': typeof AppProfileEmployerEmployerIdIndexRoute
  '/app/profile/worker/$workerId/': typeof AppProfileWorkerWorkerIdIndexRoute
  '/app/$role/_app/dashboard/shift/$shiftId': typeof AppRoleAppDashboardShiftShiftIdRoute
  '/app/$role/_app/shifts/new/': typeof AppRoleAppShiftsNewIndexRoute
  '/app/profile/employer/$employerId/ratings/': typeof AppProfileEmployerEmployerIdRatingsIndexRoute
  '/app/profile/employer/$employerId/review/': typeof AppProfileEmployerEmployerIdReviewIndexRoute
  '/app/profile/worker/$workerId/ratings/': typeof AppProfileWorkerWorkerIdRatingsIndexRoute
  '/app/profile/worker/$workerId/review/': typeof AppProfileWorkerWorkerIdReviewIndexRoute
  '/app/$role/_app/shifts/$shiftId/edit/': typeof AppRoleAppShiftsShiftIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/app/$role'
    | '/auth'
    | '/callback/stripe'
    | '/static'
    | '/auth/login'
    | '/static/welcome'
    | '/app/$role/setup'
    | '/auth/email-confirmation'
    | '/auth/forgot-password'
    | '/auth/new-password'
    | '/auth/password-reset'
    | '/auth/signup'
    | '/auth/success'
    | '/auth/verification'
    | '/callback/stripe/setup'
    | '/payment/return/$userId'
    | '/static/privacy'
    | '/static/quick-help'
    | '/static/terms'
    | '/app/profile/employer/$employerId'
    | '/app/profile/worker/$workerId'
    | '/app/$role/billing/resolve'
    | '/app/$role/setup/'
    | '/app/$role/roster/add'
    | '/app/$role/search/list'
    | '/app/profile/worker/$workerId/send-offer'
    | '/app/$role/activity'
    | '/app/$role/available'
    | '/app/$role/contact'
    | '/app/$role/dashboard'
    | '/app/$role/messages'
    | '/app/$role/payments'
    | '/app/$role/post-availability'
    | '/app/$role/roster'
    | '/app/$role/schedule'
    | '/app/$role/search'
    | '/app/$role/settings'
    | '/app/$role/shifts'
    | '/app/profile/employer/$employerId/'
    | '/app/profile/worker/$workerId/'
    | '/app/$role/dashboard/shift/$shiftId'
    | '/app/$role/shifts/new'
    | '/app/profile/employer/$employerId/ratings'
    | '/app/profile/employer/$employerId/review'
    | '/app/profile/worker/$workerId/ratings'
    | '/app/profile/worker/$workerId/review'
    | '/app/$role/shifts/$shiftId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/app/$role'
    | '/auth'
    | '/callback/stripe'
    | '/static'
    | '/auth/login'
    | '/static/welcome'
    | '/auth/email-confirmation'
    | '/auth/forgot-password'
    | '/auth/new-password'
    | '/auth/password-reset'
    | '/auth/signup'
    | '/auth/success'
    | '/auth/verification'
    | '/callback/stripe/setup'
    | '/payment/return/$userId'
    | '/static/privacy'
    | '/static/quick-help'
    | '/static/terms'
    | '/app/$role/billing/resolve'
    | '/app/$role/setup'
    | '/app/$role/roster/add'
    | '/app/$role/search/list'
    | '/app/profile/worker/$workerId/send-offer'
    | '/app/$role/activity'
    | '/app/$role/available'
    | '/app/$role/contact'
    | '/app/$role/dashboard'
    | '/app/$role/messages'
    | '/app/$role/payments'
    | '/app/$role/post-availability'
    | '/app/$role/roster'
    | '/app/$role/schedule'
    | '/app/$role/search'
    | '/app/$role/settings'
    | '/app/$role/shifts'
    | '/app/profile/employer/$employerId'
    | '/app/profile/worker/$workerId'
    | '/app/$role/dashboard/shift/$shiftId'
    | '/app/$role/shifts/new'
    | '/app/profile/employer/$employerId/ratings'
    | '/app/profile/employer/$employerId/review'
    | '/app/profile/worker/$workerId/ratings'
    | '/app/profile/worker/$workerId/review'
    | '/app/$role/shifts/$shiftId/edit'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/app/$role'
    | '/auth'
    | '/auth/_layout'
    | '/callback/stripe'
    | '/static'
    | '/static/_layout'
    | '/auth/login'
    | '/static/welcome'
    | '/app/$role/_app'
    | '/app/$role/setup'
    | '/auth/_layout/email-confirmation'
    | '/auth/_layout/forgot-password'
    | '/auth/_layout/new-password'
    | '/auth/_layout/password-reset'
    | '/auth/_layout/signup'
    | '/auth/_layout/success'
    | '/auth/_layout/verification'
    | '/callback/stripe/setup'
    | '/payment/return/$userId'
    | '/static/_layout/privacy'
    | '/static/_layout/quick-help'
    | '/static/_layout/terms'
    | '/app/profile/employer/$employerId'
    | '/app/profile/worker/$workerId'
    | '/app/$role/billing/resolve'
    | '/app/$role/setup/'
    | '/app/$role/_app/roster/add'
    | '/app/$role/_app/search/list'
    | '/app/profile/worker/$workerId/send-offer'
    | '/app/$role/_app/activity/'
    | '/app/$role/_app/available/'
    | '/app/$role/_app/contact/'
    | '/app/$role/_app/dashboard/'
    | '/app/$role/_app/messages/'
    | '/app/$role/_app/payments/'
    | '/app/$role/_app/post-availability/'
    | '/app/$role/_app/roster/'
    | '/app/$role/_app/schedule/'
    | '/app/$role/_app/search/'
    | '/app/$role/_app/settings/'
    | '/app/$role/_app/shifts/'
    | '/app/profile/employer/$employerId/'
    | '/app/profile/worker/$workerId/'
    | '/app/$role/_app/dashboard/shift/$shiftId'
    | '/app/$role/_app/shifts/new/'
    | '/app/profile/employer/$employerId/ratings/'
    | '/app/profile/employer/$employerId/review/'
    | '/app/profile/worker/$workerId/ratings/'
    | '/app/profile/worker/$workerId/review/'
    | '/app/$role/_app/shifts/$shiftId/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  CallbackStripeRouteRoute: typeof CallbackStripeRouteRouteWithChildren
  StaticRoute: typeof StaticRouteWithChildren
  PaymentReturnUserIdRoute: typeof PaymentReturnUserIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/static': {
      id: '/static'
      path: '/static'
      fullPath: '/static'
      preLoaderRoute: typeof StaticRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/static/welcome': {
      id: '/static/welcome'
      path: '/welcome'
      fullPath: '/static/welcome'
      preLoaderRoute: typeof StaticWelcomeRouteImport
      parentRoute: typeof StaticRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/static/_layout': {
      id: '/static/_layout'
      path: '/static'
      fullPath: '/static'
      preLoaderRoute: typeof StaticLayoutRouteRouteImport
      parentRoute: typeof StaticRoute
    }
    '/callback/stripe': {
      id: '/callback/stripe'
      path: '/callback/stripe'
      fullPath: '/callback/stripe'
      preLoaderRoute: typeof CallbackStripeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/_layout': {
      id: '/auth/_layout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthLayoutRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/app/$role': {
      id: '/app/$role'
      path: '/$role'
      fullPath: '/app/$role'
      preLoaderRoute: typeof AppRoleRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/static/_layout/terms': {
      id: '/static/_layout/terms'
      path: '/terms'
      fullPath: '/static/terms'
      preLoaderRoute: typeof StaticLayoutTermsRouteImport
      parentRoute: typeof StaticLayoutRouteRoute
    }
    '/static/_layout/quick-help': {
      id: '/static/_layout/quick-help'
      path: '/quick-help'
      fullPath: '/static/quick-help'
      preLoaderRoute: typeof StaticLayoutQuickHelpRouteImport
      parentRoute: typeof StaticLayoutRouteRoute
    }
    '/static/_layout/privacy': {
      id: '/static/_layout/privacy'
      path: '/privacy'
      fullPath: '/static/privacy'
      preLoaderRoute: typeof StaticLayoutPrivacyRouteImport
      parentRoute: typeof StaticLayoutRouteRoute
    }
    '/payment/return/$userId': {
      id: '/payment/return/$userId'
      path: '/payment/return/$userId'
      fullPath: '/payment/return/$userId'
      preLoaderRoute: typeof PaymentReturnUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback/stripe/setup': {
      id: '/callback/stripe/setup'
      path: '/setup'
      fullPath: '/callback/stripe/setup'
      preLoaderRoute: typeof CallbackStripeSetupRouteImport
      parentRoute: typeof CallbackStripeRouteRoute
    }
    '/auth/_layout/verification': {
      id: '/auth/_layout/verification'
      path: '/verification'
      fullPath: '/auth/verification'
      preLoaderRoute: typeof AuthLayoutVerificationRouteImport
      parentRoute: typeof AuthLayoutRouteRoute
    }
    '/auth/_layout/success': {
      id: '/auth/_layout/success'
      path: '/success'
      fullPath: '/auth/success'
      preLoaderRoute: typeof AuthLayoutSuccessRouteImport
      parentRoute: typeof AuthLayoutRouteRoute
    }
    '/auth/_layout/signup': {
      id: '/auth/_layout/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthLayoutSignupRouteImport
      parentRoute: typeof AuthLayoutRouteRoute
    }
    '/auth/_layout/password-reset': {
      id: '/auth/_layout/password-reset'
      path: '/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthLayoutPasswordResetRouteImport
      parentRoute: typeof AuthLayoutRouteRoute
    }
    '/auth/_layout/new-password': {
      id: '/auth/_layout/new-password'
      path: '/new-password'
      fullPath: '/auth/new-password'
      preLoaderRoute: typeof AuthLayoutNewPasswordRouteImport
      parentRoute: typeof AuthLayoutRouteRoute
    }
    '/auth/_layout/forgot-password': {
      id: '/auth/_layout/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthLayoutForgotPasswordRouteImport
      parentRoute: typeof AuthLayoutRouteRoute
    }
    '/auth/_layout/email-confirmation': {
      id: '/auth/_layout/email-confirmation'
      path: '/email-confirmation'
      fullPath: '/auth/email-confirmation'
      preLoaderRoute: typeof AuthLayoutEmailConfirmationRouteImport
      parentRoute: typeof AuthLayoutRouteRoute
    }
    '/app/$role/setup': {
      id: '/app/$role/setup'
      path: '/setup'
      fullPath: '/app/$role/setup'
      preLoaderRoute: typeof AppRoleSetupRouteRouteImport
      parentRoute: typeof AppRoleRouteRoute
    }
    '/app/$role/_app': {
      id: '/app/$role/_app'
      path: ''
      fullPath: '/app/$role'
      preLoaderRoute: typeof AppRoleAppRouteRouteImport
      parentRoute: typeof AppRoleRouteRoute
    }
    '/app/$role/setup/': {
      id: '/app/$role/setup/'
      path: '/'
      fullPath: '/app/$role/setup/'
      preLoaderRoute: typeof AppRoleSetupIndexRouteImport
      parentRoute: typeof AppRoleSetupRouteRoute
    }
    '/app/$role/billing/resolve': {
      id: '/app/$role/billing/resolve'
      path: '/billing/resolve'
      fullPath: '/app/$role/billing/resolve'
      preLoaderRoute: typeof AppRoleBillingResolveRouteImport
      parentRoute: typeof AppRoleRouteRoute
    }
    '/app/profile/worker/$workerId': {
      id: '/app/profile/worker/$workerId'
      path: '/profile/worker/$workerId'
      fullPath: '/app/profile/worker/$workerId'
      preLoaderRoute: typeof AppProfileWorkerWorkerIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/profile/employer/$employerId': {
      id: '/app/profile/employer/$employerId'
      path: '/profile/employer/$employerId'
      fullPath: '/app/profile/employer/$employerId'
      preLoaderRoute: typeof AppProfileEmployerEmployerIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/profile/worker/$workerId/': {
      id: '/app/profile/worker/$workerId/'
      path: '/'
      fullPath: '/app/profile/worker/$workerId/'
      preLoaderRoute: typeof AppProfileWorkerWorkerIdIndexRouteImport
      parentRoute: typeof AppProfileWorkerWorkerIdRouteRoute
    }
    '/app/profile/employer/$employerId/': {
      id: '/app/profile/employer/$employerId/'
      path: '/'
      fullPath: '/app/profile/employer/$employerId/'
      preLoaderRoute: typeof AppProfileEmployerEmployerIdIndexRouteImport
      parentRoute: typeof AppProfileEmployerEmployerIdRouteRoute
    }
    '/app/$role/_app/shifts/': {
      id: '/app/$role/_app/shifts/'
      path: '/shifts'
      fullPath: '/app/$role/shifts'
      preLoaderRoute: typeof AppRoleAppShiftsIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/settings/': {
      id: '/app/$role/_app/settings/'
      path: '/settings'
      fullPath: '/app/$role/settings'
      preLoaderRoute: typeof AppRoleAppSettingsIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/search/': {
      id: '/app/$role/_app/search/'
      path: '/search'
      fullPath: '/app/$role/search'
      preLoaderRoute: typeof AppRoleAppSearchIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/schedule/': {
      id: '/app/$role/_app/schedule/'
      path: '/schedule'
      fullPath: '/app/$role/schedule'
      preLoaderRoute: typeof AppRoleAppScheduleIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/roster/': {
      id: '/app/$role/_app/roster/'
      path: '/roster'
      fullPath: '/app/$role/roster'
      preLoaderRoute: typeof AppRoleAppRosterIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/post-availability/': {
      id: '/app/$role/_app/post-availability/'
      path: '/post-availability'
      fullPath: '/app/$role/post-availability'
      preLoaderRoute: typeof AppRoleAppPostAvailabilityIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/payments/': {
      id: '/app/$role/_app/payments/'
      path: '/payments'
      fullPath: '/app/$role/payments'
      preLoaderRoute: typeof AppRoleAppPaymentsIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/messages/': {
      id: '/app/$role/_app/messages/'
      path: '/messages'
      fullPath: '/app/$role/messages'
      preLoaderRoute: typeof AppRoleAppMessagesIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/dashboard/': {
      id: '/app/$role/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/app/$role/dashboard'
      preLoaderRoute: typeof AppRoleAppDashboardIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/contact/': {
      id: '/app/$role/_app/contact/'
      path: '/contact'
      fullPath: '/app/$role/contact'
      preLoaderRoute: typeof AppRoleAppContactIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/available/': {
      id: '/app/$role/_app/available/'
      path: '/available'
      fullPath: '/app/$role/available'
      preLoaderRoute: typeof AppRoleAppAvailableIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/activity/': {
      id: '/app/$role/_app/activity/'
      path: '/activity'
      fullPath: '/app/$role/activity'
      preLoaderRoute: typeof AppRoleAppActivityIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/profile/worker/$workerId/send-offer': {
      id: '/app/profile/worker/$workerId/send-offer'
      path: '/send-offer'
      fullPath: '/app/profile/worker/$workerId/send-offer'
      preLoaderRoute: typeof AppProfileWorkerWorkerIdSendOfferRouteImport
      parentRoute: typeof AppProfileWorkerWorkerIdRouteRoute
    }
    '/app/$role/_app/search/list': {
      id: '/app/$role/_app/search/list'
      path: '/search/list'
      fullPath: '/app/$role/search/list'
      preLoaderRoute: typeof AppRoleAppSearchListRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/roster/add': {
      id: '/app/$role/_app/roster/add'
      path: '/roster/add'
      fullPath: '/app/$role/roster/add'
      preLoaderRoute: typeof AppRoleAppRosterAddRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/profile/worker/$workerId/review/': {
      id: '/app/profile/worker/$workerId/review/'
      path: '/review'
      fullPath: '/app/profile/worker/$workerId/review'
      preLoaderRoute: typeof AppProfileWorkerWorkerIdReviewIndexRouteImport
      parentRoute: typeof AppProfileWorkerWorkerIdRouteRoute
    }
    '/app/profile/worker/$workerId/ratings/': {
      id: '/app/profile/worker/$workerId/ratings/'
      path: '/ratings'
      fullPath: '/app/profile/worker/$workerId/ratings'
      preLoaderRoute: typeof AppProfileWorkerWorkerIdRatingsIndexRouteImport
      parentRoute: typeof AppProfileWorkerWorkerIdRouteRoute
    }
    '/app/profile/employer/$employerId/review/': {
      id: '/app/profile/employer/$employerId/review/'
      path: '/review'
      fullPath: '/app/profile/employer/$employerId/review'
      preLoaderRoute: typeof AppProfileEmployerEmployerIdReviewIndexRouteImport
      parentRoute: typeof AppProfileEmployerEmployerIdRouteRoute
    }
    '/app/profile/employer/$employerId/ratings/': {
      id: '/app/profile/employer/$employerId/ratings/'
      path: '/ratings'
      fullPath: '/app/profile/employer/$employerId/ratings'
      preLoaderRoute: typeof AppProfileEmployerEmployerIdRatingsIndexRouteImport
      parentRoute: typeof AppProfileEmployerEmployerIdRouteRoute
    }
    '/app/$role/_app/shifts/new/': {
      id: '/app/$role/_app/shifts/new/'
      path: '/shifts/new'
      fullPath: '/app/$role/shifts/new'
      preLoaderRoute: typeof AppRoleAppShiftsNewIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/dashboard/shift/$shiftId': {
      id: '/app/$role/_app/dashboard/shift/$shiftId'
      path: '/dashboard/shift/$shiftId'
      fullPath: '/app/$role/dashboard/shift/$shiftId'
      preLoaderRoute: typeof AppRoleAppDashboardShiftShiftIdRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
    '/app/$role/_app/shifts/$shiftId/edit/': {
      id: '/app/$role/_app/shifts/$shiftId/edit/'
      path: '/shifts/$shiftId/edit'
      fullPath: '/app/$role/shifts/$shiftId/edit'
      preLoaderRoute: typeof AppRoleAppShiftsShiftIdEditIndexRouteImport
      parentRoute: typeof AppRoleAppRouteRoute
    }
  }
}

interface AppRoleAppRouteRouteChildren {
  AppRoleAppRosterAddRoute: typeof AppRoleAppRosterAddRoute
  AppRoleAppSearchListRoute: typeof AppRoleAppSearchListRoute
  AppRoleAppActivityIndexRoute: typeof AppRoleAppActivityIndexRoute
  AppRoleAppAvailableIndexRoute: typeof AppRoleAppAvailableIndexRoute
  AppRoleAppContactIndexRoute: typeof AppRoleAppContactIndexRoute
  AppRoleAppDashboardIndexRoute: typeof AppRoleAppDashboardIndexRoute
  AppRoleAppMessagesIndexRoute: typeof AppRoleAppMessagesIndexRoute
  AppRoleAppPaymentsIndexRoute: typeof AppRoleAppPaymentsIndexRoute
  AppRoleAppPostAvailabilityIndexRoute: typeof AppRoleAppPostAvailabilityIndexRoute
  AppRoleAppRosterIndexRoute: typeof AppRoleAppRosterIndexRoute
  AppRoleAppScheduleIndexRoute: typeof AppRoleAppScheduleIndexRoute
  AppRoleAppSearchIndexRoute: typeof AppRoleAppSearchIndexRoute
  AppRoleAppSettingsIndexRoute: typeof AppRoleAppSettingsIndexRoute
  AppRoleAppShiftsIndexRoute: typeof AppRoleAppShiftsIndexRoute
  AppRoleAppDashboardShiftShiftIdRoute: typeof AppRoleAppDashboardShiftShiftIdRoute
  AppRoleAppShiftsNewIndexRoute: typeof AppRoleAppShiftsNewIndexRoute
  AppRoleAppShiftsShiftIdEditIndexRoute: typeof AppRoleAppShiftsShiftIdEditIndexRoute
}

const AppRoleAppRouteRouteChildren: AppRoleAppRouteRouteChildren = {
  AppRoleAppRosterAddRoute: AppRoleAppRosterAddRoute,
  AppRoleAppSearchListRoute: AppRoleAppSearchListRoute,
  AppRoleAppActivityIndexRoute: AppRoleAppActivityIndexRoute,
  AppRoleAppAvailableIndexRoute: AppRoleAppAvailableIndexRoute,
  AppRoleAppContactIndexRoute: AppRoleAppContactIndexRoute,
  AppRoleAppDashboardIndexRoute: AppRoleAppDashboardIndexRoute,
  AppRoleAppMessagesIndexRoute: AppRoleAppMessagesIndexRoute,
  AppRoleAppPaymentsIndexRoute: AppRoleAppPaymentsIndexRoute,
  AppRoleAppPostAvailabilityIndexRoute: AppRoleAppPostAvailabilityIndexRoute,
  AppRoleAppRosterIndexRoute: AppRoleAppRosterIndexRoute,
  AppRoleAppScheduleIndexRoute: AppRoleAppScheduleIndexRoute,
  AppRoleAppSearchIndexRoute: AppRoleAppSearchIndexRoute,
  AppRoleAppSettingsIndexRoute: AppRoleAppSettingsIndexRoute,
  AppRoleAppShiftsIndexRoute: AppRoleAppShiftsIndexRoute,
  AppRoleAppDashboardShiftShiftIdRoute: AppRoleAppDashboardShiftShiftIdRoute,
  AppRoleAppShiftsNewIndexRoute: AppRoleAppShiftsNewIndexRoute,
  AppRoleAppShiftsShiftIdEditIndexRoute: AppRoleAppShiftsShiftIdEditIndexRoute,
}

const AppRoleAppRouteRouteWithChildren = AppRoleAppRouteRoute._addFileChildren(
  AppRoleAppRouteRouteChildren,
)

interface AppRoleSetupRouteRouteChildren {
  AppRoleSetupIndexRoute: typeof AppRoleSetupIndexRoute
}

const AppRoleSetupRouteRouteChildren: AppRoleSetupRouteRouteChildren = {
  AppRoleSetupIndexRoute: AppRoleSetupIndexRoute,
}

const AppRoleSetupRouteRouteWithChildren =
  AppRoleSetupRouteRoute._addFileChildren(AppRoleSetupRouteRouteChildren)

interface AppRoleRouteRouteChildren {
  AppRoleAppRouteRoute: typeof AppRoleAppRouteRouteWithChildren
  AppRoleSetupRouteRoute: typeof AppRoleSetupRouteRouteWithChildren
  AppRoleBillingResolveRoute: typeof AppRoleBillingResolveRoute
}

const AppRoleRouteRouteChildren: AppRoleRouteRouteChildren = {
  AppRoleAppRouteRoute: AppRoleAppRouteRouteWithChildren,
  AppRoleSetupRouteRoute: AppRoleSetupRouteRouteWithChildren,
  AppRoleBillingResolveRoute: AppRoleBillingResolveRoute,
}

const AppRoleRouteRouteWithChildren = AppRoleRouteRoute._addFileChildren(
  AppRoleRouteRouteChildren,
)

interface AppProfileEmployerEmployerIdRouteRouteChildren {
  AppProfileEmployerEmployerIdIndexRoute: typeof AppProfileEmployerEmployerIdIndexRoute
  AppProfileEmployerEmployerIdRatingsIndexRoute: typeof AppProfileEmployerEmployerIdRatingsIndexRoute
  AppProfileEmployerEmployerIdReviewIndexRoute: typeof AppProfileEmployerEmployerIdReviewIndexRoute
}

const AppProfileEmployerEmployerIdRouteRouteChildren: AppProfileEmployerEmployerIdRouteRouteChildren =
  {
    AppProfileEmployerEmployerIdIndexRoute:
      AppProfileEmployerEmployerIdIndexRoute,
    AppProfileEmployerEmployerIdRatingsIndexRoute:
      AppProfileEmployerEmployerIdRatingsIndexRoute,
    AppProfileEmployerEmployerIdReviewIndexRoute:
      AppProfileEmployerEmployerIdReviewIndexRoute,
  }

const AppProfileEmployerEmployerIdRouteRouteWithChildren =
  AppProfileEmployerEmployerIdRouteRoute._addFileChildren(
    AppProfileEmployerEmployerIdRouteRouteChildren,
  )

interface AppProfileWorkerWorkerIdRouteRouteChildren {
  AppProfileWorkerWorkerIdSendOfferRoute: typeof AppProfileWorkerWorkerIdSendOfferRoute
  AppProfileWorkerWorkerIdIndexRoute: typeof AppProfileWorkerWorkerIdIndexRoute
  AppProfileWorkerWorkerIdRatingsIndexRoute: typeof AppProfileWorkerWorkerIdRatingsIndexRoute
  AppProfileWorkerWorkerIdReviewIndexRoute: typeof AppProfileWorkerWorkerIdReviewIndexRoute
}

const AppProfileWorkerWorkerIdRouteRouteChildren: AppProfileWorkerWorkerIdRouteRouteChildren =
  {
    AppProfileWorkerWorkerIdSendOfferRoute:
      AppProfileWorkerWorkerIdSendOfferRoute,
    AppProfileWorkerWorkerIdIndexRoute: AppProfileWorkerWorkerIdIndexRoute,
    AppProfileWorkerWorkerIdRatingsIndexRoute:
      AppProfileWorkerWorkerIdRatingsIndexRoute,
    AppProfileWorkerWorkerIdReviewIndexRoute:
      AppProfileWorkerWorkerIdReviewIndexRoute,
  }

const AppProfileWorkerWorkerIdRouteRouteWithChildren =
  AppProfileWorkerWorkerIdRouteRoute._addFileChildren(
    AppProfileWorkerWorkerIdRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppRoleRouteRoute: typeof AppRoleRouteRouteWithChildren
  AppProfileEmployerEmployerIdRouteRoute: typeof AppProfileEmployerEmployerIdRouteRouteWithChildren
  AppProfileWorkerWorkerIdRouteRoute: typeof AppProfileWorkerWorkerIdRouteRouteWithChildren
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppRoleRouteRoute: AppRoleRouteRouteWithChildren,
  AppProfileEmployerEmployerIdRouteRoute:
    AppProfileEmployerEmployerIdRouteRouteWithChildren,
  AppProfileWorkerWorkerIdRouteRoute:
    AppProfileWorkerWorkerIdRouteRouteWithChildren,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthLayoutRouteRouteChildren {
  AuthLayoutEmailConfirmationRoute: typeof AuthLayoutEmailConfirmationRoute
  AuthLayoutForgotPasswordRoute: typeof AuthLayoutForgotPasswordRoute
  AuthLayoutNewPasswordRoute: typeof AuthLayoutNewPasswordRoute
  AuthLayoutPasswordResetRoute: typeof AuthLayoutPasswordResetRoute
  AuthLayoutSignupRoute: typeof AuthLayoutSignupRoute
  AuthLayoutSuccessRoute: typeof AuthLayoutSuccessRoute
  AuthLayoutVerificationRoute: typeof AuthLayoutVerificationRoute
}

const AuthLayoutRouteRouteChildren: AuthLayoutRouteRouteChildren = {
  AuthLayoutEmailConfirmationRoute: AuthLayoutEmailConfirmationRoute,
  AuthLayoutForgotPasswordRoute: AuthLayoutForgotPasswordRoute,
  AuthLayoutNewPasswordRoute: AuthLayoutNewPasswordRoute,
  AuthLayoutPasswordResetRoute: AuthLayoutPasswordResetRoute,
  AuthLayoutSignupRoute: AuthLayoutSignupRoute,
  AuthLayoutSuccessRoute: AuthLayoutSuccessRoute,
  AuthLayoutVerificationRoute: AuthLayoutVerificationRoute,
}

const AuthLayoutRouteRouteWithChildren = AuthLayoutRouteRoute._addFileChildren(
  AuthLayoutRouteRouteChildren,
)

interface AuthRouteChildren {
  AuthLayoutRouteRoute: typeof AuthLayoutRouteRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLayoutRouteRoute: AuthLayoutRouteRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface CallbackStripeRouteRouteChildren {
  CallbackStripeSetupRoute: typeof CallbackStripeSetupRoute
}

const CallbackStripeRouteRouteChildren: CallbackStripeRouteRouteChildren = {
  CallbackStripeSetupRoute: CallbackStripeSetupRoute,
}

const CallbackStripeRouteRouteWithChildren =
  CallbackStripeRouteRoute._addFileChildren(CallbackStripeRouteRouteChildren)

interface StaticLayoutRouteRouteChildren {
  StaticLayoutPrivacyRoute: typeof StaticLayoutPrivacyRoute
  StaticLayoutQuickHelpRoute: typeof StaticLayoutQuickHelpRoute
  StaticLayoutTermsRoute: typeof StaticLayoutTermsRoute
}

const StaticLayoutRouteRouteChildren: StaticLayoutRouteRouteChildren = {
  StaticLayoutPrivacyRoute: StaticLayoutPrivacyRoute,
  StaticLayoutQuickHelpRoute: StaticLayoutQuickHelpRoute,
  StaticLayoutTermsRoute: StaticLayoutTermsRoute,
}

const StaticLayoutRouteRouteWithChildren =
  StaticLayoutRouteRoute._addFileChildren(StaticLayoutRouteRouteChildren)

interface StaticRouteChildren {
  StaticLayoutRouteRoute: typeof StaticLayoutRouteRouteWithChildren
  StaticWelcomeRoute: typeof StaticWelcomeRoute
}

const StaticRouteChildren: StaticRouteChildren = {
  StaticLayoutRouteRoute: StaticLayoutRouteRouteWithChildren,
  StaticWelcomeRoute: StaticWelcomeRoute,
}

const StaticRouteWithChildren =
  StaticRoute._addFileChildren(StaticRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  CallbackStripeRouteRoute: CallbackStripeRouteRouteWithChildren,
  StaticRoute: StaticRouteWithChildren,
  PaymentReturnUserIdRoute: PaymentReturnUserIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
